import React from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import ScrollToTop from "../components/ScrollToTop";
import { ToastContainer, Zoom, toast } from "react-toastify";
const OldDashboardLayout = () => {
    const { userInfo } = useSelector((state) => state.auth);
  return (
    <>
         <ScrollToTop/>
         <ToastContainer
              position="top-right"
              autoClose={2000}
              hideProgressBar
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
          transition={Zoom}
          theme="light"
          toastClassName={({ type }) =>
          `relative flex justify-between items-center gap-2 shadow-xl rounded-xl p-4 ${
            type === "success"
              ? "bg-green-50 border-green-500 text-green-800"
              : "bg-red-50 border-red-500 text-red-800"
          }`
        }
        bodyClassName="text-lg font-large text-gray-800"
/>
       <div className="containerpro-afterlogin md:p-0">
        <div
        className={
          userInfo ? "containerpro-afterlogin md:p-0" : "containerpro md:p-0"
        }
      >
        <Header />
        {userInfo && <Sidebar />}
        <div
          className={userInfo ? "midcontainer-afterlogin p-6" : "midcontainer"}
        >
          <Outlet />
        </div>
        <Footer />
      </div>
    </div>
    </>
  );
};

export default OldDashboardLayout;
